<template>
  <div class="wrapper-create-exam">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- name: 'CommonExam-PracticeManagement' -->
        <el-breadcrumb-item
          @click.native="$router.go(-1)"
          class="breadcrumb-item-back"
          >返回</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        <el-breadcrumb-item>编辑练习</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--试卷名称-->
    <div class="step1" v-if="tab == 0">
      <span class="name">试卷名称</span>
      <el-input
        size="small"
        class="content"
        v-model="papername"
        placeholder="请输入试卷名称"
      ></el-input>
    </div>

    <div class="step2" v-if="tab == 1">
      <div class="bank">
        <el-form
          size="mini"
          :inline="true"
          :model="form_bank"
          class="demo-form-inline"
        >
          <el-form-item label="科目" required>
            <el-select
              v-model="form_bank.subject_id"
              placeholder="请选择"
              filterable
              @change="getSchoolQuestionBankListForPostExam"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subjectList"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="类型">
            <el-select
              v-model="form_bank.bank_type"
              placeholder="选择题库类型"
              @change="getSchoolQuestionBankListForPostExam"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="平台题库" value="1"></el-option>
              <el-option label="校区题库" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="题库名称">
            <el-input
              style="width: 250px"
              v-model="form.bank_name"
              placeholder="请输入题库名称"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search_btn"
              plain
              size="mini"
              icon="el-icon-search"
              @click="getSchoolQuestionBankListForPostExam"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <el-table
        class="questtable"
        ref="questtable"
        size="mini"
        highlight-current-row
        :data="questionbanklist"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa' }"
        @current-change="handleSelectionChange"
      >
        <el-table-column align="center" width="100" label="封面">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 50px"
              :src="scope.row.cover_url"
              fit="fill"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.educational_institution_id">校区题库</span>
            <span v-else>平台题库</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="题库名称" prop="title">
        </el-table-column>
        <el-table-column align="center" label="题目数量" prop="question_num">
        </el-table-column>

        <el-table-column align="center" label="创建人" prop="realname">
        </el-table-column>

        <el-table-column align="center" label="创建时间" prop="created_time">
        </el-table-column>
      </el-table>

      <el-pagination
        class="pages"
        @current-change="handleCurrentChange"
        :current-page.sync="form_bank.page_no"
        layout="total, prev, pager, next"
        :page-size="form_bank.page_size"
        :total="form_bank.total"
      ></el-pagination>
    </div>

    <div class="step3" v-if="tab == 2">
      <el-row :gutter="20">
        <el-col :span="8">
          <div>
            <el-card class="question_modal" shadow="hover">
              <el-radio v-model="question_modal" label="1"
                >顺序选题 <i class="el-icon-s-unfold"></i>
              </el-radio>
            </el-card>
          </div>
        </el-col>

        <el-col :span="8">
          <div>
            <el-card class="question_modal" shadow="hover">
              <el-radio v-model="question_modal" label="2"
                >随机选题 <i class="el-icon-s-operation"></i>
              </el-radio>
            </el-card>
          </div>
        </el-col>

        <el-col :span="8">
          <div>
            <el-card class="question_modal" shadow="hover">
              <el-radio v-model="question_modal" label="3"
                >手动选题 <i class="el-icon-s-custom"></i>
              </el-radio>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--随机选题和顺序出题-->
    <div
      class="modal_random"
      v-if="(tab == 2 && question_modal == '1') || question_modal == '2'"
    >
      <div
        class="label"
        v-if="(tab == 2 && question_modal == '1') || question_modal == '2'"
      >
        设置数量
      </div>

      <div
        class="setnum"
        v-if="(tab == 2 && question_modal == '1') || question_modal == '2'"
      >
        <div class="onechoice" v-if="form_state.onechoice">
          <el-tag size="mini">单选题</el-tag>
          <span class="onechoice_num"
            >(共{{ form_state.onechoice_arr.length }}题)</span
          >
          <span class="choose_onechoice">抽取</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.onechoice_num"
            :min="0"
            :max="this.form_state.onechoice_arr.length"
            label="单选题数量"
          ></el-input-number>
          <span>题</span>

          <span style="margin-left: 100px">每题</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.onechoice_score"
            :min="1"
            :max="10"
            label="单选题分数"
          ></el-input-number>
          <span>分</span>
        </div>

        <div class="onechoice" v-if="form_state.multi_choice">
          <el-tag size="mini">多选题</el-tag>
          <span class="onechoice_num"
            >(共{{ form_state.multi_choice_arr.length }}题)</span
          >
          <span class="choose_onechoice">抽取</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.multi_choice_num"
            :min="0"
            :max="form_state.multi_choice_arr.length"
            label="多选题数量"
          ></el-input-number>
          <span>题</span>

          <span style="margin-left: 100px">每题</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.multi_choice_score"
            :min="1"
            :max="10"
            label="多选题分数"
          ></el-input-number>
          <span>分</span>
        </div>

        <div class="onechoice" v-if="form_state.judge_choice">
          <el-tag size="mini">判断题</el-tag>
          <span class="onechoice_num"
            >(共{{ form_state.judge_choice_arr.length }}题)</span
          >
          <span class="choose_onechoice">抽取</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.judge_choice_num"
            :min="0"
            :max="form_state.judge_choice_arr.length"
            label="判断题数量"
          ></el-input-number>
          <span>题</span>

          <span style="margin-left: 100px">每题</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.judge_choice_score"
            :min="1"
            :max="10"
            label="判断题分数"
          ></el-input-number>
          <span>分</span>
        </div>

        <div class="onechoice" v-if="form_state.space_choice">
          <el-tag size="mini">填空题</el-tag>
          <span class="onechoice_num"
            >(共{{ form_state.space_choice_arr.length }}题)</span
          >
          <span class="choose_onechoice">抽取</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.space_choice_num"
            :min="0"
            :max="form_state.space_choice_arr.length"
            label="判断题数量"
          ></el-input-number>
          <span>题</span>

          <span style="margin-left: 100px">每题</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.space_choice_score"
            :min="1"
            :max="10"
            label="填空题分数"
          ></el-input-number>
          <span>分</span>
        </div>

        <div class="onechoice" v-if="form_state.blank_choice">
          <el-tag size="mini">简答题</el-tag>
          <span class="onechoice_num"
            >(共{{ form_state.blank_choice_arr.length }}题)</span
          >
          <span class="choose_onechoice">抽取</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.blank_choice_arr.length"
            :min="0"
            :max="form_state.blank_choice_num"
            label="简答题数量"
          ></el-input-number>
          <span>题</span>

          <span style="margin-left: 100px">每题</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.blank_choice_score"
            :min="1"
            :max="20"
            label="简答题分数"
          ></el-input-number>
          <span>分</span>
        </div>

        <div class="onechoice" v-if="form_state.comprehensive_choice">
          <el-tag size="mini">综合题</el-tag>
          <span class="onechoice_num"
            >(共{{ form_state.comprehensive_choice_arr.length }}题)</span
          >
          <span class="choose_onechoice">抽取</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.comprehensive_choice_num"
            :min="0"
            :max="form_state.comprehensive_choice_arr.length"
            label="综合题数量"
          ></el-input-number>
          <span>题</span>

          <span style="margin-left: 100px">每题</span>
          <el-input-number
            class="onechoice_input_num"
            size="mini"
            v-model="form_state.comprehensive_choice_score"
            :min="1"
            :max="20"
            label="综合题分数"
          ></el-input-number>
          <span>分</span>
        </div>
      </div>
    </div>

    <!--手动出题-->
    <div class="modal_byhand" v-if="tab == 2 && question_modal == '3'">
      <div>
        <el-popover placement="right" trigger="click">
          <el-button
            :disabled="!form_state.onechoice"
            size="mini"
            type="info"
            @click="AddQuestionType('1')"
            >单选题
          </el-button>
          <el-button
            :disabled="!form_state.multi_choice"
            size="mini"
            type="info"
            @click="AddQuestionType('2')"
            >多选题
          </el-button>
          <el-button
            :disabled="!form_state.judge_choice"
            size="mini"
            type="info"
            @click="AddQuestionType('3')"
            >判断题
          </el-button>
          <el-button
            :disabled="!form_state.space_choice"
            size="mini"
            type="info"
            @click="AddQuestionType('4')"
            >填空题
          </el-button>
          <el-button
            :disabled="!form_state.blank_choice"
            size="mini"
            type="info"
            @click="AddQuestionType('5')"
            >简答题
          </el-button>
          <el-button
            :disabled="!form_state.comprehensive_choice"
            size="mini"
            type="info"
            @click="AddQuestionType('6')"
          >
            综合题</el-button
          >

          <el-button size="mini" slot="reference" type="primary"
            >添加题型</el-button
          >
        </el-popover>
      </div>

      <el-row :gutter="20">
        <el-col :span="18">
          <div class="question_type">
            <el-card
              class="box-card"
              shadow="hover"
              v-if="form_state.onechoice_hand"
            >
              <div slot="header" class="clearfix">
                <span class="type">单选题</span>
                <i class="el-icon-close" @click="CloseQuestionType('1')"></i>
                <i class="el-icon-circle-plus" @click="AddQuestion('1')"></i>
              </div>

              <div
                class="question-content"
                v-for="(item, index) of form_state.onechoice_arr_hand"
                :key="index"
                :id="item.index + 1"
              >
                <div class="question-info">
                  <div style="width: 50px">
                    <el-tag
                      class="question-sort"
                      size="mini"
                      type="primary"
                      effect="dark"
                      >{{ index + 1 }}</el-tag
                    >
                  </div>
                  <div>
                    <span class="question-title" v-html="item.title"></span>
                  </div>
                </div>

                <div class="answer-otions">
                  <div
                    class="option-wrapper"
                    v-for="(option, index) of JSON.parse(item.options)"
                    :key="index"
                  >
                    <span class="option-tab">
                      <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio>
                    </span>

                    <div class="option-input" v-html="option.content"></div>
                  </div>
                </div>

                <div class="answer-setting">
                  <span>设置分数</span>
                  <el-input-number
                    class="set_score"
                    size="mini"
                    v-model="item.score"
                    @input="onInput('1')"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                  ></el-input-number>

                  <span class="control">
                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-top"
                      @click="TopSwap(index, '1')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-bottom"
                      @click="DownSwap(index, '1')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-delete"
                      @click="DeleteQuestion(index, '1')"
                      circle
                    ></el-button>
                  </span>
                  <el-divider></el-divider>
                </div>
              </div>
            </el-card>

            <!--多选题-->
            <el-card
              style="margin-top: 20px"
              class="box-card"
              shadow="hover"
              v-if="form_state.multi_choice_hand"
            >
              <div slot="header" class="clearfix">
                <span class="type">多选题</span>
                <i class="el-icon-close" @click="CloseQuestionType('2')"></i>
                <i class="el-icon-circle-plus" @click="AddQuestion('2')"></i>
              </div>

              <div
                class="question-content"
                v-for="(item, index) of form_state.multi_choice_arr_hand"
                :key="index"
                :id="item.index + 1"
              >
                <div class="question-info">
                  <div style="width: 50px">
                    <el-tag
                      class="question-sort"
                      size="mini"
                      type="primary"
                      effect="dark"
                      >{{ index + 1 }}</el-tag
                    >
                  </div>
                  <div>
                    <span class="question-title" v-html="item.title"></span>
                  </div>
                </div>

                <div class="answer-otions">
                  <div
                    class="option-wrapper"
                    v-for="(option, index) of JSON.parse(item.options)"
                    :key="index"
                  >
                    <span class="option-tab">
                      <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio>
                    </span>

                    <div class="option-input" v-html="option.content"></div>
                  </div>
                </div>

                <div class="answer-setting">
                  <span>设置分数</span>
                  <el-input-number
                    class="set_score"
                    size="mini"
                    v-model="item.score"
                    @input="onInput('2')"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                  ></el-input-number>

                  <span class="control">
                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-top"
                      @click="TopSwap(index, '2')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-bottom"
                      @click="DownSwap(index, '2')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-delete"
                      @click="DeleteQuestion(index, '2')"
                      circle
                    ></el-button>
                  </span>
                  <el-divider></el-divider>
                </div>
              </div>
            </el-card>

            <!--判断题-->
            <el-card
              style="margin-top: 20px"
              class="box-card"
              shadow="hover"
              v-if="form_state.judge_choice_hand"
            >
              <div slot="header" class="clearfix">
                <span class="type">判断题</span>
                <i class="el-icon-close" @click="CloseQuestionType('3')"></i>
                <i class="el-icon-circle-plus" @click="AddQuestion('3')"></i>
              </div>

              <div
                class="question-content"
                v-for="(item, index) of form_state.judge_choice_arr_hand"
                :key="index"
                :id="item.index + 1"
              >
                <div class="question-info">
                  <div style="width: 50px">
                    <el-tag
                      class="question-sort"
                      size="mini"
                      type="primary"
                      effect="dark"
                      >{{ index + 1 }}</el-tag
                    >
                  </div>
                  <div>
                    <span class="question-title" v-html="item.title"></span>
                  </div>
                </div>

                <div class="answer-otions">
                  <div
                    class="option-wrapper"
                    v-for="(option, index) of JSON.parse(item.options)"
                    :key="index"
                  >
                    <span class="option-tab" v-if="option.content">
                      <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio>
                    </span>

                    <div
                      class="option-input"
                      v-if="option.content"
                      v-html="option.content"
                    ></div>
                  </div>
                </div>

                <div class="answer-setting">
                  <span>设置分数</span>
                  <el-input-number
                    class="set_score"
                    size="mini"
                    v-model="item.score"
                    @input="onInput('3')"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                  ></el-input-number>

                  <span class="control">
                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-top"
                      @click="TopSwap(index, '3')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-bottom"
                      @click="DownSwap(index, '3')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-delete"
                      @click="DeleteQuestion(index, '3')"
                      circle
                    ></el-button>
                  </span>
                  <el-divider></el-divider>
                </div>
              </div>
            </el-card>

            <!--填空题-->
            <el-card
              style="margin-top: 20px"
              class="box-card"
              shadow="hover"
              v-if="form_state.space_choice_hand"
            >
              <div slot="header" class="clearfix">
                <span class="type">填空题</span>
                <i class="el-icon-close" @click="CloseQuestionType('4')"></i>
                <i class="el-icon-circle-plus" @click="AddQuestion('4')"></i>
              </div>

              <div
                class="question-content"
                v-for="(item, index) of form_state.space_choice_arr_hand"
                :key="index"
                :id="item.index + 1"
              >
                <div class="question-info">
                  <div style="width: 50px">
                    <el-tag
                      class="question-sort"
                      size="mini"
                      type="primary"
                      effect="dark"
                      >{{ index + 1 }}</el-tag
                    >
                  </div>
                  <div>
                    <span class="question-title" v-html="item.title"></span>
                  </div>
                </div>

                <div class="answer-otions">
                  <div
                    class="option-wrapper"
                    v-for="(option, index) of JSON.parse(item.options)"
                    :key="index"
                  >
                    <span class="option-tab" v-if="option.content">
                      <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio>
                    </span>

                    <div
                      class="option-input"
                      v-if="option.content"
                      v-html="option.content"
                    ></div>
                  </div>
                </div>

                <div class="answer-setting">
                  <span>设置分数</span>
                  <el-input-number
                    class="set_score"
                    size="mini"
                    v-model="item.score"
                    @input="onInput('4')"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                  ></el-input-number>

                  <span class="control">
                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-top"
                      @click="TopSwap(index, '4')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-bottom"
                      @click="DownSwap(index, '4')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-delete"
                      @click="DeleteQuestion(index, '4')"
                      circle
                    ></el-button>
                  </span>
                  <el-divider></el-divider>
                </div>
              </div>
            </el-card>

            <!--简答题-->
            <el-card
              style="margin-top: 20px"
              class="box-card"
              shadow="hover"
              v-if="form_state.blank_choice_hand"
            >
              <div slot="header" class="clearfix">
                <span class="type">简答题</span>
                <i class="el-icon-close" @click="CloseQuestionType('5')"></i>
                <i class="el-icon-circle-plus" @click="AddQuestion('5')"></i>
              </div>

              <div
                class="question-content"
                v-for="(item, index) of form_state.blank_choice_arr_hand"
                :key="index"
                :id="item.index + 1"
              >
                <div class="question-info">
                  <div style="width: 50px">
                    <el-tag
                      class="question-sort"
                      size="mini"
                      type="primary"
                      effect="dark"
                      >{{ index + 1 }}</el-tag
                    >
                  </div>
                  <div>
                    <span class="question-title" v-html="item.title"></span>
                  </div>
                </div>

                <div class="answer-otions">
                  <div
                    class="option-wrapper"
                    v-for="(option, index) of JSON.parse(item.options)"
                    :key="index"
                  >
                    <span class="option-tab" v-if="option.content">
                      <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio>
                    </span>

                    <div
                      class="option-input"
                      v-if="option.content"
                      v-html="option.content"
                    ></div>
                  </div>
                </div>

                <div class="answer-setting">
                  <span>设置分数</span>
                  <el-input-number
                    class="set_score"
                    size="mini"
                    v-model="item.score"
                    @input="onInput('5')"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                  ></el-input-number>

                  <span class="control">
                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-top"
                      @click="TopSwap(index, '5')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-bottom"
                      @click="DownSwap(index, '5')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-delete"
                      @click="DeleteQuestion(index, '5')"
                      circle
                    ></el-button>
                  </span>
                  <el-divider></el-divider>
                </div>
              </div>
            </el-card>

            <!--综合题-->
            <el-card
              style="margin-top: 20px"
              class="box-card"
              shadow="hover"
              v-if="form_state.comprehensive_choice_hand"
            >
              <div slot="header" class="clearfix">
                <span class="type">综合题</span>
                <i class="el-icon-close" @click="CloseQuestionType('6')"></i>
                <i class="el-icon-circle-plus" @click="AddQuestion('6')"></i>
              </div>

              <div
                class="question-content"
                v-for="(item,
                index) of form_state.comprehensive_choice_arr_hand"
                :key="index"
                :id="item.index + 1"
              >
                <div class="question-info">
                  <div style="width: 50px">
                    <el-tag
                      class="question-sort"
                      size="mini"
                      type="primary"
                      effect="dark"
                      >{{ index + 1 }}</el-tag
                    >
                  </div>
                  <div>
                    <span class="question-title" v-html="item.title"></span>
                  </div>
                </div>

                <div class="answer-otions">
                  <div
                    class="option-wrapper"
                    v-for="(option, index) of JSON.parse(item.options)"
                    :key="index"
                  >
                    <span class="option-tab" v-if="option.content">
                      <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio>
                    </span>

                    <div
                      class="option-input"
                      v-if="option.content"
                      v-html="option.content"
                    ></div>
                  </div>
                </div>

                <div class="answer-setting">
                  <span>设置分数</span>
                  <el-input-number
                    class="set_score"
                    size="mini"
                    v-model="item.score"
                    @input="onInput('6')"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                  ></el-input-number>

                  <span class="control">
                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-top"
                      @click="TopSwap(index, '6')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-bottom"
                      @click="DownSwap(index, '6')"
                      circle
                    >
                    </el-button>

                    <el-button
                      size="mini"
                      type="plain"
                      icon="el-icon-delete"
                      @click="DeleteQuestion(index, '6')"
                      circle
                    ></el-button>
                  </span>
                  <el-divider></el-divider>
                </div>
              </div>
            </el-card>

            <span
              v-if="
                !form_state.onechoice_hand &&
                  !form_state.multi_choice_hand &&
                  !form_state.judge_choice_hand &&
                  !form_state.space_choice_hand &&
                  !form_state.blank_choice_hand &&
                  !form_state.comprehensive_choice_hand
              "
              style="margin-left: 50%"
              ><i class="el-icon-folder-opened"></i>暂无数据</span
            >
          </div>
        </el-col>
        <el-col :span="6">
          <div class="question_scoreset">
            <el-card shadow="always">
              <div class="question-set">
                <i class="el-icon-setting"></i>
                分数设置
              </div>

              <div class="set_type" v-if="form_state.onechoice_hand">
                <div class="set_type_onchoice">单选题</div>
                <div class="set_num">
                  <span class="total_num"
                    >共 {{ form_state.onechoice_arr_hand.length }} 题</span
                  >
                  <span class="total_score"
                    >共 {{ form_state.onechoice_total_score }} 分</span
                  >
                </div>

                <div class="set_score">
                  <span class="every_score">每题</span>
                  <el-input-number
                    class="every_score_num"
                    size="mini"
                    v-model="form_state.onechoice_everyscore"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    @change="SetEveryScore('1')"
                  ></el-input-number>
                  <span class="every_score_label">分</span>
                </div>
              </div>

              <div class="set_type" v-if="form_state.multi_choice_hand">
                <div class="set_type_onchoice">多选题</div>
                <div class="set_num">
                  <span class="total_num"
                    >共 {{ form_state.multi_choice_arr_hand.length }} 题</span
                  >
                  <span class="total_score"
                    >共 {{ form_state.multi_choice_total_score }} 分</span
                  >
                </div>

                <div class="set_score">
                  <span class="every_score">每题</span>
                  <el-input-number
                    class="every_score_num"
                    size="mini"
                    v-model="form_state.multi_choice_everyscore"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    @change="SetEveryScore('2')"
                  ></el-input-number>
                  <span class="every_score_label">分</span>
                </div>
              </div>

              <div class="set_type" v-if="form_state.judge_choice_hand">
                <div class="set_type_onchoice">判断题</div>
                <div class="set_num">
                  <span class="total_num"
                    >共 {{ form_state.judge_choice_arr_hand.length }} 题</span
                  >
                  <span class="total_score"
                    >共 {{ form_state.judge_choice_total_score }} 分</span
                  >
                </div>

                <div class="set_score">
                  <span class="every_score">每题</span>
                  <el-input-number
                    class="every_score_num"
                    size="mini"
                    v-model="form_state.judge_choice_everyscore"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    @change="SetEveryScore('3')"
                  ></el-input-number>
                  <span class="every_score_label">分</span>
                </div>
              </div>

              <div class="set_type" v-if="form_state.space_choice_hand">
                <div class="set_type_onchoice">填空题</div>
                <div class="set_num">
                  <span class="total_num"
                    >共 {{ form_state.space_choice_arr_hand.length }} 题</span
                  >
                  <span class="total_score"
                    >共 {{ form_state.space_choice_total_score }} 分</span
                  >
                </div>

                <div class="set_score">
                  <span class="every_score">每题</span>
                  <el-input-number
                    class="every_score_num"
                    size="mini"
                    v-model="form_state.space_choice_everyscore"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    @change="SetEveryScore('4')"
                  ></el-input-number>
                  <span class="every_score_label">分</span>
                </div>
              </div>

              <div class="set_type" v-if="form_state.blank_choice_hand">
                <div class="set_type_onchoice">简答题</div>
                <div class="set_num">
                  <span class="total_num"
                    >共 {{ form_state.blank_choice_arr_hand.length }} 题</span
                  >
                  <span class="total_score"
                    >共 {{ form_state.blank_choice_total_score }} 分</span
                  >
                </div>

                <div class="set_score">
                  <span class="every_score">每题</span>
                  <el-input-number
                    class="every_score_num"
                    size="mini"
                    v-model="form_state.blank_choice_everyscore"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    @change="SetEveryScore('5')"
                  ></el-input-number>
                  <span class="every_score_label">分</span>
                </div>
              </div>

              <div class="set_type" v-if="form_state.comprehensive_choice_hand">
                <div class="set_type_onchoice">综合题</div>
                <div class="set_num">
                  <span class="total_num"
                    >共
                    {{ form_state.comprehensive_choice_arr_hand.length }}
                    题</span
                  >
                  <span class="total_score"
                    >共
                    {{ form_state.comprehensive_choice_total_score }} 分</span
                  >
                </div>

                <div class="set_score">
                  <span class="every_score">每题</span>
                  <el-input-number
                    class="every_score_num"
                    size="mini"
                    v-model="form_state.comprehensive_choice_everyscore"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    @change="SetEveryScore('6')"
                  ></el-input-number>
                  <span class="every_score_label">分</span>
                </div>
              </div>

              <el-divider></el-divider>

              <div class="question-total">
                <i class="el-icon-s-grid"></i>
                考试题数

                <span>{{ question_total_num }}</span>
              </div>
              <div class="question-total">
                <i class="el-icon-s-marketing"></i>
                试卷总分

                <span>{{ question_total_score }}</span>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="step4" v-if="tab == 3">
      <el-card shadow="never">
        <div class="base_setting">
          <div>基础配置</div>
          <div>
            <el-form
              class="form_exam"
              ref="form"
              :model="form_exam"
              label-width="80px"
              size="mini"
              label-position="right"
            >
              <el-form-item label="练习名称" required>
                <el-input
                  style="width: 200px"
                  class="exam_name"
                  v-model="form_exam.name"
                  placeholder="请输入本次练习名称"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="练习时间" required>
                <el-date-picker
                  v-model="form_exam.value"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  placement="bottom-start"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="练习说明">
                <el-input
                  type="textarea"
                  v-model="form_exam.desc"
                  placeholder="请输入本次考试说明"
                ></el-input>
              </el-form-item>
              <el-form-item label="练习状态">
                <el-switch
                  v-model="form_exam.post_state"
                  active-text="开启"
                  inactive-text="关闭"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="显示解析">
                <el-switch
                  v-model="form_exam.is_show_answer"
                  active-text="开启"
                  inactive-text="关闭"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="解析" v-if="form_exam.is_show_answer">
                <el-radio v-model="form_exam.show_answer_type" label="2"
                  >实时反馈</el-radio
                >
                <el-radio v-model="form_exam.show_answer_type" label="1"
                  >提交后显示解析</el-radio
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>

      <div class="control">
        <el-button
          size="mini"
          type="primary"
          v-if="tab !== 1 && tab < 3"
          @click="PrevStep"
          >上一步</el-button
        >

        <el-button
          size="mini"
          type="primary"
          v-if="tab == 3"
          @click="SubmitPractice"
          >保存信息</el-button
        >

        <el-button size="mini" type="primary" v-if="tab < 3" @click="NextStep"
          >下一步</el-button
        >
      </div>
    </div>

    <!--按班级添加学员-->

    <el-dialog title="按班级添加学员" :visible.sync="dialogVisible" width="80%">
      <div class="header">
        <el-form
          class="form-style"
          :model="form_class"
          size="mini"
          :inline="true"
          required
        >
          <el-form-item label="所属校区" required>
            <el-select
              v-model="form_class.school_id"
              @change="getCampusCurriculumtList"
            >
              <el-option
                v-for="(item, index) of schoolList"
                :key="index"
                :label="item.campusName"
                :value="item.dept_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="授课类型" required>
            <el-select
              v-model="form_class.teaching_type"
              placeholder="请选择"
              style="width: 150px"
              @change="getCampusCurriculumtList"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="面授课" value="1"></el-option>
              <el-option label="直播课" value="2"></el-option>
              <el-option label="录播课" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课程体系">
            <el-select
              v-model="form_class.curriculum_id"
              clearable
              @change="getExamClassListForPostExam"
            >
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) of curriculum_list"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <br />

          <el-form-item label="班级名称">
            <el-input
              style="width: 200px"
              v-model="form_class.classname"
              placeholder="请输入名称"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search_btn"
              plain
              size="mini"
              icon="el-icon-search"
              @click="getExamClassListForPostExam"
            >
              搜索</el-button
            >
            <el-checkbox
              v-model="form_class.owned"
              style="margin-left: 20px"
              @change="getExamClassListForPostExam"
              >我的班级
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          class="questtable"
          ref="multipleTable"
          size="mini"
          :data="classList"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
          @selection-change="handleSelectionChange1"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column align="left" label="班级名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.teaching_type == '1'">面授课</span>
              <span v-else-if="scope.row.teaching_type == '2'">直播课</span>
              <span v-else-if="scope.row.teaching_type == '3'">录播课</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="上课时间">
            <template slot-scope="scope">
              <span>{{ scope.row.week_str }} / {{ scope.row.time_str }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="班级人数" prop="stuNum">
          </el-table-column>
          <el-table-column align="left" label="上课老师" prop="lectureName">
          </el-table-column>

          <el-table-column align="left" label="所属校区" prop="campusName">
          </el-table-column>
        </el-table>
      </div>

      <div style="margin: 20px; text-align: right">
        <el-pagination
          class="pages"
          @current-change="handleCurrentChange1"
          :current-page.sync="class_page_no"
          layout="total, prev, pager, next"
          :page-size="class_page_size"
          :total="class_total"
        ></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="getStudentsByClass"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!--单学员添加学员-->

    <el-dialog title="单学员添加" :visible.sync="dialogVisible1" width="80%">
      <div class="header">
        <el-form
          class="form-style"
          :model="form_stu"
          size="mini"
          :inline="true"
        >
          <el-form-item label="所属校区" prop="school_id">
            <el-select
              v-model="form_stu.school_id"
              @change="getExamStuListForPostExam"
            >
              <el-option
                v-for="(item, index) of schoolList"
                :key="index"
                :label="item.campusName"
                :value="item.dept_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学员姓名" prop="realname">
            <el-input
              style="width: 200px"
              v-model="form_stu.realname"
              placeholder="请输入名称"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="学员状态" prop="stu_state" required>
            <el-select
              v-model="form_stu.stu_state"
              placeholder="请选择"
              style="width: 150px"
              @change="getExamStuListForPostExam"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="试听" value="1"></el-option>
              <el-option label="在读" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search_btn"
              plain
              size="mini"
              icon="el-icon-search"
              @click="getExamStuListForPostExam"
              >搜索
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          class="questtable"
          ref="questtable"
          size="mini"
          :data="form_stu.stulist"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
          @selection-change="handleSelectionChange2"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column
            align="left"
            label="学员姓名"
            prop="studentUserInfo.realname"
          >
          </el-table-column>

          <el-table-column align="left" label="学生账号" prop="name">
          </el-table-column>
          <el-table-column align="left" label="所属班级">
            <template slot-scope="scope">
              <span v-for="item of scope.row.stuClassArr" :key="item.id">
                <span>{{ item.classInfo.name }}</span>
                <br />
              </span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="所属校区" prop="campusName">
          </el-table-column>
        </el-table>
      </div>
      <div style="margin: 20px; text-align: right">
        <el-pagination
          class="pages"
          @current-change="handleCurrentChange2"
          :current-page.sync="form_stu.page_no"
          layout="total, prev, pager, next"
          :page-size="form_stu.page_size"
          :total="form_stu.total"
        ></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible1 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="Choose_student"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!--试题管理-->

    <el-dialog title="添加试题" :visible.sync="dialogVisible2" width="80%">
      <div class="header">
        <el-form
          class="form-style"
          :model="form_question"
          size="mini"
          :inline="true"
        >
          <el-form-item label="试题名称" prop="title">
            <el-input
              style="width: 200px"
              v-model="form_question.title"
              placeholder="请输入名称"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="questions">
        <el-table
          size="mini"
          ref="multipleTable"
          :data="questionlist_hand"
          :header-cell-style="{ background: '#f5f7fa' }"
          @selection-change="handleSelectionQuestion"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="question_title" v-html="props.row.title"></div>

              <div
                class="options"
                v-for="(item, index) of JSON.parse(props.row.options)"
                :key="index"
              >
                <div v-if="item.content" class="options_title">
                  {{ item.title }}、
                </div>

                <div v-if="item.content" class="options_content">
                  <div class="content" v-html="item.content"></div>
                </div>
              </div>

              <div class="answer">
                <span class="answer_label">正确答案:</span>
                <span
                  v-if="
                    props.row.type == '1' ||
                      props.row.type == '2' ||
                      props.row.type == '3' ||
                      props.row.type == '4'
                  "
                  class="answer_content"
                  v-html="props.row.answer"
                ></span>
                <span v-else-if="props.row.type == '5'">简答题答案</span>
                <span v-else-if="props.row.type == '6'">综合题答案</span>
              </div>

              <div class="analysis">
                <span class="analysis_label">试题解析:</span>
                <span
                  class="analysis_content"
                  v-html="props.row.analysis"
                ></span>
              </div>
            </template>
          </el-table-column>

          <el-table-column align="left" width="50" label="编号" prop="sort_num">
          </el-table-column>

          <el-table-column align="left" label="题型">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">单选题</span>
              <span v-else-if="scope.row.type == 2">多选题</span>
              <span v-else-if="scope.row.type == 3">判断题</span>
              <span v-else-if="scope.row.type == 4">填空题</span>
              <span v-else-if="scope.row.type == 5">简答题</span>
              <span v-else-if="scope.row.type == 6">综合题</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="题目" prop="title_str">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.title_str"
                placement="top-start"
              >
                <span
                  style="
                    max-width: 150px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  >{{ scope.row.title_str }}</span
                >
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="答案">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.type == '1' ||
                    scope.row.type == '2' ||
                    scope.row.type == '3'
                "
                >{{ scope.row.answer }}</span
              >
              <span v-else-if="scope.row.type == '4'">简答题答案</span>
              <span v-else-if="scope.row.type == '5'">综合题答案</span>
            </template>
            <span></span>
          </el-table-column>

          <el-table-column
            align="center"
            width="150"
            label="创建时间"
            prop="created_time"
          >
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="InsertQuestion"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getZoneSchoolSubjectList } from '@/api/community'

import {
  getSchoolQuestionBankListForPostExam,
  getExamQuestionListForPostExam,
  getUserCampusList,
  getCampusCurriculumtList,
  getExamClassListForPostExam,
  getExamStuListByClassIdsForPostExam,
  getExamStuListForPostExam,
  addPaper,
  editPractice,
} from '@/api/educational'

import uploadFile from '@/config/uploadFile'

export default {
  name: 'CommonExam-EditPractice',

  data() {
    return {
      uploadFileTime: false,
      radio: '',
      tab: 3,
      papername: '', // 试卷名称
      new_paper_id: '', //试卷id
      question_modal: '1', //选题模式
      subjectList: [],
      questionBankIds: [], //题库id组
      question_type: '', //试题类型
      question_type_hand: '', //手动选题类型

      dialogVisible: false, //按班级添加学员
      dialogVisible1: false, //单个学员添加
      dialogVisible2: false, //添加试题
      checked: true,

      //题库试题状态
      form_state: {
        onechoice: false,
        onechoice_num: 0,
        onechoice_score: 0,
        onechoice_arr: [],
        onechoice_arr_hand: [],
        onechoice_hand: false,
        onechoice_total_score: 0,
        onechoice_everyscore: 0, //每题多少分

        multi_choice: false,
        multi_choice_num: 0,
        multi_choice_score: 0,
        multi_choice_arr: [],
        multi_choice_arr_hand: [],
        multi_choice_hand: false,
        multi_choice_total_score: 0,
        multi_choice_everyscore: 0,

        judge_choice: false,
        judge_choice_num: 0,
        judge_choice_score: 0,
        judge_choice_arr: [],
        judge_choice_arr_hand: [],
        judge_choice_hand: false,
        judge_choice_total_score: 0,
        judge_choice_everyscore: 0,

        space_choice: false,
        space_choice_num: 0,
        space_choice_score: 0,
        space_choice_arr: [],
        space_choice_arr_hand: [],
        space_choice_hand: false,
        space_choice_total_score: 0,
        space_choice_everyscore: 0,

        blank_choice: false,
        blank_choice_num: 0,
        blank_choice_score: 0,
        blank_choice_arr: [],
        blank_choice_arr_hand: [],
        blank_choice_hand: false,
        blank_choice_total_score: 0,
        blank_choice_everyscore: 0,

        comprehensive_choice: false,
        comprehensive_choice_num: 0,
        comprehensive_choice_score: 0,
        comprehensive_choice_arr: [],
        comprehensive_choice_arr_hand: [],
        comprehensive_choice_hand: false,
        comprehensive_choice_total_score: 0,
        comprehensive_choice_everyscore: 0,
      },

      //题库来源搜索
      form_bank: {
        subject_id: '', //所属科目
        bank_type: '',
        bank_name: '',
        page_no: 1,
        page_size: 20,
        total: 0,
      },

      form_class: {
        school_id: '', //分校id
        teaching_type: '', //授课类型
        curriculum_id: '', //课程体系id
        classname: '', //班级名称
        owned: true, //自我班级
        page_no: 1,
        page_size: 10,
        total: 0,
      },

      form_question: {
        type: '',
        title: '',
      },

      //班级多选
      classList: [],
      selectList: [],
      selectListStu: [], //准备的学员列表
      studentList: [], //参考学员

      class_page_no: 1,
      class_page_size: 10,
      class_total: 0,

      form_stu: {
        school_id: '', //校区id
        realname: '', //真实姓名
        stulist: [],
        stu_state: '',
        page_no: 1,
        page_size: 20,
        total: 0,
      },

      schoolList: [], //所属校区列表
      curriculum_list: [], //课程体系列表

      form: {
        question_a: "print('Hello World')",
        question_b: '',
        question_c: '',
        question_d: '',
        resolution: '这个问题,应该这样回答？',
      },

      //考试配置
      form_exam: {
        show_answer_type: '2',
        name: '',
        exam_duration: 45, //考试时长
        passing_score: 60, //及格分数
        value: [],
        post_state: null,
        desc: '',
        is_show_answer: null,
      },
      //试卷配置
      form_paper: {
        answer_modal: '1',
        score_modal: '1',
        multi_score_modal: '1',
        space_score_modal: '1',
        exam_duration: 45, //考试时长
        passing_score: 60, //及格分数
        value1: '',
        value2: '',
        submit_num: 1, //交卷次数
      },
      //主题设置
      form_theme: {
        imgList: [],
      },
      //成绩设置
      form_score: {
        ranking: true,
        analysis: true,
      },

      options: [
        {
          id: 1,
          value: '0.1',
          label: '10%',
        },
        {
          id: 2,
          value: '0.2',
          label: '20%',
        },
        {
          id: 3,
          value: '0.3',
          label: '30%',
        },
        {
          id: 4,
          value: '0.4',
          label: '40%',
        },
        {
          id: 5,
          value: '0.5',
          label: '50%',
        },
        {
          id: 6,
          value: '0.6',
          label: '60%',
        },
        {
          id: 7,
          value: '0.7',
          label: '70%',
        },
        {
          id: 8,
          value: '选项5',
          label: '80%',
        },
        {
          id: 9,
          value: '0.7',
          label: '90%',
        },
      ],

      originalData: [], //后台返回的原始数据

      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
        },
      ],
      search: '',
      value: '',

      //页面

      input: '',
      questionbanklist: [], //题库列表
      questionlist: [], //试题列表
      questionlist_hand: [], //手动选题库
      questionlist_store: [], //试题选择，暂存列表

      //试卷题目列表
      questionArr: [], //[{"id":"1","score":"1"}] 题目列表
      paper_score: 0, //总分

      //
      campusIds: [], //考试分校id组
      classArr: [], //考试班级id组
      stuArr: [], //考试学生id组

      page_no: 1,
      page_size: 20,
      total: 0,

      title: '',
      practiceInfo: {},
      backPath: '',
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name) {
        vm.backPath = from.path
        window.sessionStorage.setItem('examBackPath', from.path)
      } else {
        next()
      }
    })
  },
  //搜索数据
  computed: {
    filterData: function() {
      return this.studentList.filter(
        (data) =>
          !this.search ||
          data.studentUserInfo.realname
            .toLowerCase()
            .includes(this.search.toLowerCase())
      )
    },

    question_total_num: function() {
      return (
        this.form_state.onechoice_arr_hand.length +
        this.form_state.multi_choice_arr_hand.length +
        this.form_state.judge_choice_arr_hand.length +
        this.form_state.space_choice_arr_hand.length +
        this.form_state.blank_choice_arr_hand.length +
        this.form_state.comprehensive_choice_arr_hand.length
      )
    },
    question_total_score: function() {
      return parseFloat(
        this.form_state.onechoice_total_score +
          this.form_state.multi_choice_total_score +
          this.form_state.judge_choice_total_score +
          this.form_state.space_choice_total_score +
          this.form_state.blank_choice_total_score +
          this.form_state.comprehensive_choice_total_score
      ).toFixed(1)
    },
  },

  mounted() {
    this.title = this.$route.query.title
    this.practiceInfo = this.$route.params.practiceInfo
    console.log('练习详情1')
    console.log(this.practiceInfo)
    this.form_exam.name = this.practiceInfo.title
    this.form_exam.show_answer_type = this.practiceInfo.show_answer_type.toString()

    this.form_exam.value = this.FormatDate(
      this.practiceInfo.start_date,
      this.practiceInfo.end_date
    )
    this.form_exam.desc = this.practiceInfo.content
    this.form_exam.post_state =
      this.practiceInfo.post_state === 1 ? true : false
    this.form_exam.is_show_answer =
      this.practiceInfo.is_show_answer === 1 ||
      this.practiceInfo.is_show_answer === true
        ? true
        : false

    const backPath = window.sessionStorage.getItem('examBackPath')
    if (backPath) {
      this.backPath = backPath
    }
  },

  methods: {
    FormatDate(state_date, end_date) {
      var start = state_date.split(' ')
      var end = end_date.split(' ')

      var start_y = start[0].split('-')[0]
      var start_m = start[0].split('-')[1]
      var start_d = start[0].split('-')[2]

      var start_hh = start[1].split(':')[0]
      var start_mm = start[1].split(':')[1]
      var start_ss = start[1].split(':')[2]

      var end_y = end[0].split('-')[0]
      var end_m = end[0].split('-')[1]
      var end_d = end[0].split('-')[2]

      var end_hh = end[1].split(':')[0]
      var end_mm = end[1].split(':')[1]
      var end_ss = end[1].split(':')[2]

      return [
        new Date(start_y, start_m - 1, start_d, start_hh, start_mm, start_ss),
        new Date(end_y, end_m - 1, end_d, end_hh, end_mm, end_ss),
      ]
    },
    onInput(type) {
      this.$forceUpdate()

      if (type == '1') {
        console.log(this.form_state.onechoice_arr_hand)
        this.form_state.onechoice_total_score = 0
        for (let k = 0; k < this.form_state.onechoice_arr_hand.length; k++) {
          this.form_state.onechoice_total_score =
            this.form_state.onechoice_total_score +
            this.form_state.onechoice_arr_hand[k].score
        }
      } else if (type == '2') {
        console.log(this.form_state.multi_choice_arr_hand)
        this.form_state.multi_choice_total_score = 0
        for (let k = 0; k < this.form_state.multi_choice_arr_hand.length; k++) {
          this.form_state.multi_choice_total_score =
            this.form_state.multi_choice_total_score +
            this.form_state.multi_choice_arr_hand[k].score
        }
      } else if (type == '3') {
        console.log(this.form_state.judge_choice_arr_hand)
        this.form_state.judge_choice_total_score = 0
        for (let k = 0; k < this.form_state.judge_choice_arr_hand.length; k++) {
          this.form_state.judge_choice_total_score =
            this.form_state.judge_choice_total_score +
            this.form_state.judge_choice_arr_hand[k].score
        }
      } else if (type == '4') {
        console.log(this.form_state.space_choice_arr_hand)
        this.form_state.space_choice_total_score = 0
        for (let k = 0; k < this.form_state.space_choice_arr_hand.length; k++) {
          this.form_state.space_choice_total_score =
            this.form_state.space_choice_total_score +
            this.form_state.space_choice_arr_hand[k].score
        }
      } else if (type == '5') {
        console.log(this.form_state.blank_choice_arr_hand)
        this.form_state.blank_choice_total_score = 0
        for (let k = 0; k < this.form_state.blank_choice_arr_hand.length; k++) {
          this.form_state.blank_choice_total_score =
            this.form_state.blank_choice_total_score +
            this.form_state.blank_choice_arr_hand[k].score
        }
      } else if (type == '6') {
        console.log(this.form_state.comprehensive_choice_arr_hand)
        this.form_state.comprehensive_choice_total_score = 0
        for (
          let k = 0;
          k < this.form_state.comprehensive_choice_arr_hand.length;
          k++
        ) {
          this.form_state.comprehensive_choice_total_score =
            this.form_state.comprehensive_choice_total_score +
            this.form_state.comprehensive_choice_arr_hand[k].score
        }
      }
    },

    //每题分数 快捷录入
    SetEveryScore(type) {
      if (type == '1') {
        for (let k = 0; k < this.form_state.onechoice_arr_hand.length; k++) {
          this.form_state.onechoice_arr_hand[
            k
          ].score = this.form_state.onechoice_everyscore
        }
      } else if (type == '2') {
        for (let k = 0; k < this.form_state.multi_choice_arr_hand.length; k++) {
          this.form_state.multi_choice_arr_hand[
            k
          ].score = this.form_state.multi_choice_everyscore
        }
      } else if (type == '3') {
        for (let k = 0; k < this.form_state.judge_choice_arr_hand.length; k++) {
          this.form_state.judge_choice_arr_hand[
            k
          ].score = this.form_state.judge_choice_everyscore
        }
      } else if (type == '4') {
        for (let k = 0; k < this.form_state.space_choice_arr_hand.length; k++) {
          this.form_state.space_choice_arr_hand[
            k
          ].score = this.form_state.space_choice_everyscore
        }
      } else if (type == '5') {
        for (let k = 0; k < this.form_state.blank_choice_arr_hand.length; k++) {
          this.form_state.blank_choice_arr_hand[
            k
          ].score = this.form_state.blank_choice_everyscore
        }
      } else if (type == '6') {
        for (
          let k = 0;
          k < this.form_state.comprehensive_choice_arr_hand.length;
          k++
        ) {
          this.form_state.comprehensive_choice_arr_hand[
            k
          ].score = this.form_state.comprehensive_choice_everyscore
        }
      }
    },

    uploadFile() {},
    handleRemove() {},

    AddQuestionType(type) {
      console.log('添加题型')
      console.log(type)

      if (type == '1') {
        if (this.form_state.onechoice_hand) {
          this.$message.warning('已有该题型')
          return
        }
        this.form_state.onechoice_hand = true
      } else if (type == '2') {
        if (this.form_state.multi_choice_hand) {
          this.$message.warning('已有该题型')
          return
        }
        this.form_state.multi_choice_hand = true
      } else if (type == '3') {
        if (this.form_state.judge_choice_hand) {
          this.$message.warning('已有该题型')
          return
        }
        this.form_state.judge_choice_hand = true
      } else if (type == '4') {
        if (this.form_state.space_choice_hand) {
          this.$message.warning('已有该题型')
          return
        }
        this.form_state.space_choice_hand = true
      } else if (type == '5') {
        if (this.form_state.blank_choice_hand) {
          this.$message.warning('已有该题型')
          return
        }
        this.form_state.blank_choice_hand = true
      } else if (type == '6') {
        if (this.form_state.comprehensive_choice_hand) {
          this.$message.warning('已有该题型')
          return
        }
        this.form_state.comprehensive_choice_hand = true
      }
    },

    CloseQuestionType(type) {
      console.log('关闭题型')
      console.log(type)
      if (type == '1') {
        this.form_state.onechoice_hand = false
      } else if (type == '2') {
        this.form_state.multi_choice_hand = false
      } else if (type == '3') {
        this.form_state.judge_choice_hand = false
      } else if (type == '4') {
        this.form_state.space_choice_hand = false
      } else if (type == '5') {
        this.form_state.blank_choice_hand = false
      } else if (type == '6') {
        this.form_state.comprehensive_choice_hand = false
      }
    },

    AddQuestion(type) {
      console.log('添加题型')
      console.log(type)
      this.question_type_hand = type

      getExamQuestionListForPostExam({
        questionBankIds: JSON.stringify(this.questionBankIds),
        type: type,
      }).then((res) => {
        console.log('列出题型下面的所有试题')
        console.log(res)
        this.questionlist_hand = res.questionList

        for (let k = 0; k < this.questionlist_hand.length; k++) {
          //分数初始化
          this.questionlist_hand[k].score = 0
        }
      })
      this.dialogVisible2 = true
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.form_theme.imgList = res
          this.uploadFileTime = false
        }
      )
    },

    DeleteQuestion(index, type) {
      console.log(index, type)

      if (type == '1') {
        this.form_state.onechoice_arr_hand.splice(index, 1)
        console.log(this.form_state.onechoice_arr)
      } else if (type == '2') {
        this.form_state.multi_choice_arr_hand.splice(index, 1)
        console.log(this.form_state.multi_choice_arr_hand)
      } else if (type == '3') {
        this.form_state.judge_choice_arr_hand.splice(index, 1)
        console.log(this.form_state.judge_choice_arr_hand)
      } else if (type == '4') {
        this.form_state.space_choice_arr_hand.splice(index, 1)
        console.log(this.form_state.space_choice_arr_hand)
      } else if (type == '5') {
        this.form_state.blank_choice_arr_hand.splice(index, 1)
        console.log(this.form_state.blank_choice_arr_hand)
      } else if (type == '6') {
        this.form_state.comprehensive_choice_arr_hand.splice(index, 1)
        console.log(this.form_state.comprehensive_choice_arr_hand)
      }
    },

    handleSelectionQuestion(val) {
      console.log('选择试题')
      this.questionlist_store = val
    },

    InsertQuestion() {
      console.log('插入试题')
      console.log(this.questionlist_store)
      if (this.questionlist_store.length == 0) {
        this.$message.warning('请选择试题')
        return
      }

      if (this.question_type_hand == '1') {
        this.form_state.onechoice_arr_hand = this.form_state.onechoice_arr_hand.concat(
          this.questionlist_store
        )
        this.form_state.onechoice_arr_hand = this.unique(
          this.form_state.onechoice_arr_hand
        )
        console.log('已选择的单选题')
        console.log(this.form_state.onechoice_arr_hand)
      } else if (this.question_type_hand == '2') {
        this.form_state.multi_choice_arr_hand = this.form_state.multi_choice_arr_hand.concat(
          this.questionlist_store
        )
        this.form_state.multi_choice_arr_hand = this.unique(
          this.form_state.multi_choice_arr_hand
        )
        console.log('已选择的多选题')
        console.log(this.form_state.multi_choice_arr_hand)
      } else if (this.question_type_hand == '3') {
        this.form_state.judge_choice_arr_hand = this.form_state.judge_choice_arr_hand.concat(
          this.questionlist_store
        )
        this.form_state.judge_choice_arr_hand = this.unique(
          this.form_state.judge_choice_arr_hand
        )
        console.log('已选择的判断题')
        console.log(this.form_state.judge_choice_arr_hand)
      } else if (this.question_type_hand == '4') {
        this.form_state.space_choice_arr_hand = this.form_state.space_choice_arr_hand.concat(
          this.questionlist_store
        )
        this.form_state.space_choice_arr_hand = this.unique(
          this.form_state.space_choice_arr_hand
        )
        console.log('已选择的填空题')
        console.log(this.form_state.space_choice_arr_hand)
      } else if (this.question_type_hand == '5') {
        this.form_state.blank_choice_arr_hand = this.form_state.blank_choice_arr_hand.concat(
          this.questionlist_store
        )
        this.form_state.blank_choice_arr_hand = this.unique(
          this.form_state.blank_choice_arr_hand
        )
        console.log('已选择的简答题')
        console.log(this.form_state.blank_choice_arr_hand)
      } else if (this.question_type_hand == '6') {
        this.form_state.comprehensive_choice_arr_hand = this.form_state.comprehensive_choice_arr_hand.concat(
          this.questionlist_store
        )
        this.form_state.comprehensive_choice_arr_hand = this.unique(
          this.form_state.comprehensive_choice_arr_hand
        )
        console.log('已选择的综合题')
        console.log(this.form_state.comprehensive_choice_arr_hand)
      }
      this.dialogVisible2 = false
    },

    //两个元素互换位置
    swapArr(arr, index1, index2) {
      /*数组两个元素位置互换*/
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },

    TopSwap(index, type) {
      console.log(index)
      console.log(type)
      if (type == '1') {
        if (index == 0) {
          this.$message.warning('已到顶端')
          return
        } else {
          this.form_state.onechoice_arr_hand = this.swapArr(
            this.form_state.onechoice_arr_hand,
            index,
            index - 1
          )
        }
      } else if (type == '2') {
        if (index == 0) {
          this.$message.warning('已到顶端')
          return
        } else {
          this.form_state.multi_choice_arr_hand = this.swapArr(
            this.form_state.multi_choice_arr_hand,
            index,
            index - 1
          )
        }
      } else if (type == '3') {
        if (index == 0) {
          this.$message.warning('已到顶端')
          return
        } else {
          this.form_state.judge_choice_arr_hand = this.swapArr(
            this.form_state.judge_choice_arr_hand,
            index,
            index - 1
          )
        }
      }
    },

    DownSwap(index, type) {
      console.log(index)
      console.log(type)
      if (type == '1') {
        if (index == this.form_state.onechoice_arr_hand.length - 1) {
          this.$message.warning('已到底端')
          return
        } else {
          this.form_state.onechoice_arr_hand = this.swapArr(
            this.form_state.onechoice_arr_hand,
            index,
            index + 1
          )
        }
      } else if (type == '2') {
        if (index == this.form_state.multi_choice_arr_hand.length - 1) {
          this.$message.warning('已到底端')
          return
        } else {
          this.form_state.multi_choice_arr_hand = this.swapArr(
            this.form_state.multi_choice_arr_hand,
            index,
            index + 1
          )
        }
      } else if (type == '3') {
        if (index == this.form_state.judge_choice_arr_hand.length - 1) {
          this.$message.warning('已到底端')
          return
        } else {
          this.form_state.judge_choice_arr_hand = this.swapArr(
            this.form_state.judge_choice_arr_hand,
            index,
            index + 1
          )
        }
      }
    },

    handleEdit(index, row) {
      console.log(index, row)
    },
    handleDelete(index, row) {
      console.log('移除参考人员')
      console.log(index, row)

      this.studentList.splice(index, 1)
    },

    // 获取校区
    getUserCampusList(cmd) {
      if (cmd == '1') {
        this.dialogVisible = true
      } else if (cmd == '2') {
        this.dialogVisible1 = true
      }

      getUserCampusList().then((res) => {
        this.schoolList = res.userDeptList

        if (cmd == '1') {
          if (this.schoolList.length > 0) {
            this.form_class.school_id = this.schoolList[0].dept_id
          }
          this.getCampusCurriculumtList()
          this.getExamClassListForPostExam()
        } else if (cmd == '2') {
          console.log('单学员添加')
          if (this.schoolList.length > 0) {
            this.form_stu.school_id = this.schoolList[0].dept_id
          }

          this.getExamStuListForPostExam()
        }
      })
    },

    //获得学员列表
    getExamStuListForPostExam() {
      getExamStuListForPostExam({
        campusId: this.form_stu.school_id,
        normal_state: this.form_stu.stu_state,
        realname: this.form_stu.realname,
        page_no: this.form_stu.page_no,
        page_size: this.form_stu.page_size,
      }).then((res) => {
        console.log('单学员添加-学员列表')
        console.log(res)
        this.form_stu.stulist = res.studentList
        this.form_stu.total = res.total
      })
    },

    //获取学校公开课课程体系
    getCampusCurriculumtList() {
      this.curriculum_list = []

      getCampusCurriculumtList({
        campusId: this.form_class.school_id,
        subjectId: this.form_bank.subject_id,
        teaching_type: this.form_class.teaching_type,
        class_type: '1',
      }).then((res) => {
        console.log('获取学校常规课课程体系')
        console.log(res)
        this.curriculum_list = res.campusCurriculumList
      })
    },

    getExamClassListForPostExam() {
      getExamClassListForPostExam({
        campusId: this.form_class.school_id,
        subject_id: this.form_bank.subject_id,
        curriculumId: this.form_class.curriculum_id,
        className: this.form_class.classname,
        isShowSelfClass: this.form_class.owned,
        teachingType: this.form_class.teaching_type,
        page_no: this.class_page_no,
        page_size: this.class_page_size,
      }).then((res) => {
        console.log('班级学员')
        console.log(res)
        this.classList = res.classList
        this.class_total = res.total
      })
    },

    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log('校区科目')
        console.log(res)
        this.subjectList = res.subjectList

        if (this.subjectList.length !== 0) {
          this.form_bank.subject_id = this.subjectList[0].id
          this.getSchoolQuestionBankListForPostExam()
        }
      })
    },

    //题库来源查询
    getSchoolQuestionBankListForPostExam() {
      getSchoolQuestionBankListForPostExam({
        subject_id: this.form_bank.subject_id,
        title: this.form_bank.bank_name,
        search_question_bank_type: this.form_bank.bank_type,
        page_no: this.form_bank.page_no,
        page_size: this.form_bank.page_size,
      }).then((res) => {
        console.log('题库来源')
        console.log(res)
        this.questionbanklist = res.questionBankList
        this.form_bank.total = res.total
      })
    },

    NextStep() {
      if (this.tab !== 4) {
        if (this.tab == '0') {
          this.getZoneSchoolSubjectList()
        } else if (this.tab == '1') {
          if (this.questionBankIds.length == 0) {
            this.$message.warning('请选择题库')
            return
          }
          console.log('列出所有题目')
          this.tab = 2
        } else if (this.tab == '2') {
          console.log('开始选题')
          console.log(this.question_modal)
          console.log(this.form_state)

          this.questionArr = []

          if (this.question_modal == '1') {
            console.log('顺序选题')
            //添加单选题
            if (this.form_state.onechoice_arr) {
              for (let k = 0; k < this.form_state.onechoice_num; k++) {
                const question = {
                  id: this.form_state.onechoice_arr[k].id,
                  score: this.form_state.onechoice_score,
                }
                this.questionArr.push(question)
              }
            }
            //添加多选题
            if (this.form_state.multi_choice_arr) {
              for (let k = 0; k < this.form_state.multi_choice_num; k++) {
                const question = {
                  id: this.form_state.multi_choice_arr[k].id,
                  score: this.form_state.multi_choice_score,
                }
                this.questionArr.push(question)
              }
            }
            //添加判断题
            if (this.form_state.judge_choice_arr) {
              for (let k = 0; k < this.form_state.judge_choice_num; k++) {
                const question = {
                  id: this.form_state.judge_choice_arr[k].id,
                  score: this.form_state.judge_choice_score,
                }
                this.questionArr.push(question)
              }
            }
            //添加填空题
            if (this.form_state.space_choice_arr) {
              for (let k = 0; k < this.form_state.space_choice_num; k++) {
                const question = {
                  id: this.form_state.space_choice_arr[k].id,
                  score: this.form_state.space_choice_score,
                }
                this.questionArr.push(question)
              }
            }
            //添加简答题
            if (this.form_state.blank_choice_arr) {
              for (let k = 0; k < this.form_state.blank_choice_num; k++) {
                const question = {
                  id: this.form_state.blank_choice_arr[k].id,
                  score: this.form_state.blank_choice_score,
                }
                this.questionArr.push(question)
              }
            }
            //添加综合题
            if (this.form_state.comprehensive_choice_arr) {
              for (
                let k = 0;
                k < this.form_state.comprehensive_choice_num;
                k++
              ) {
                const question = {
                  id: this.form_state.comprehensive_choice_arr[k].id,
                  score: this.form_state.comprehensive_choice_score,
                }
                this.questionArr.push(question)
              }
            }

            //计算总分
            for (let k = 0; k < this.questionArr.length; k++) {
              this.paper_score = this.paper_score + this.questionArr[k].score
              console.log('试题分数')
              console.log(this.questionArr[k].score)
            }

            console.log('试卷试题:')
            console.log(this.questionArr)
            console.log(this.paper_score)

            //生成试卷
            this.addPaper()
          } else if (this.question_modal == '2') {
            console.log('随机选题')
            console.log(this.question_modal)

            //添加单选题
            if (this.form_state.onechoice_arr) {
              for (let k = 0; k < this.form_state.onechoice_num; k++) {
                const range = this.form_state.onechoice_num - k
                const random = Math.floor(Math.random() * range)
                const question = {
                  id: this.form_state.onechoice_arr[random].id,
                  score: this.form_state.onechoice_score,
                }
                this.questionArr.push(question)
                this.form_state.onechoice_arr.splice(random, 1)
              }
            }

            //添加多选题
            if (this.form_state.multi_choice_arr) {
              for (let k = 0; k < this.form_state.multi_choice_num; k++) {
                const range = this.form_state.multi_choice_num - k
                const random = Math.floor(Math.random() * range)
                const question = {
                  id: this.form_state.multi_choice_arr[random].id,
                  score: this.form_state.multi_choice_score,
                }
                this.questionArr.push(question)
                this.form_state.multi_choice_arr.splice(random, 1)
              }
            }

            //添加判断题
            if (this.form_state.judge_choice_arr) {
              for (let k = 0; k < this.form_state.judge_choice_num; k++) {
                const range = this.form_state.judge_choice_num - k
                const random = Math.floor(Math.random() * range)
                const question = {
                  id: this.form_state.judge_choice_arr[random].id,
                  score: this.form_state.judge_choice_score,
                }
                this.questionArr.push(question)
                this.form_state.judge_choice_arr.splice(random, 1)
              }
            }

            //添加填空题
            if (this.form_state.space_choice_arr) {
              for (let k = 0; k < this.form_state.space_choice_num; k++) {
                const range = this.form_state.space_choice_num - k
                const random = Math.floor(Math.random() * range)
                const question = {
                  id: this.form_state.space_choice_arr[random].id,
                  score: this.form_state.space_choice_score,
                }
                this.questionArr.push(question)
                this.form_state.space_choice_arr.splice(random, 1)
              }
            }

            //添加简答题
            if (this.form_state.blank_choice_arr) {
              for (let k = 0; k < this.form_state.blank_choice_num; k++) {
                const range = this.form_state.blank_choice_num - k
                const random = Math.floor(Math.random() * range)
                const question = {
                  id: this.form_state.blank_choice_arr[random].id,
                  score: this.form_state.blank_choice_score,
                }
                this.questionArr.push(question)
                this.form_state.blank_choice_arr.splice(random, 1)
              }
            }

            //添加综合题
            if (this.form_state.comprehensive_choice_arr) {
              for (
                let k = 0;
                k < this.form_state.comprehensive_choice_num;
                k++
              ) {
                const range = this.form_state.comprehensive_choice_num - k
                const random = Math.floor(Math.random() * range)
                const question = {
                  id: this.form_state.comprehensive_choice_arr[random].id,
                  score: this.form_state.comprehensive_choice_score,
                }
                this.questionArr.push(question)
                this.form_state.comprehensive_choice_arr.splice(random, 1)
              }
            }

            //计算总分
            for (let k = 0; k < this.questionArr.length; k++) {
              this.paper_score = this.paper_score + this.questionArr[k].score
              console.log('试题分数')
              console.log(this.questionArr[k].score)
            }

            console.log('试卷试题:')
            console.log(this.questionArr)
            console.log(this.paper_score)

            //生成试卷
            this.addPaper()
          } else if (this.question_modal == '3') {
            console.log('手动选题')
            //添加单选题
            if (this.form_state.onechoice_arr_hand) {
              for (
                let k = 0;
                k < this.form_state.onechoice_arr_hand.length;
                k++
              ) {
                const question = {
                  id: this.form_state.onechoice_arr_hand[k].id,
                  score: this.form_state.onechoice_arr_hand[k].score,
                }
                this.questionArr.push(question)
              }
            }
            //添加多选题
            if (this.form_state.multi_choice_arr_hand) {
              for (
                let k = 0;
                k < this.form_state.multi_choice_arr_hand.length;
                k++
              ) {
                const question = {
                  id: this.form_state.multi_choice_arr_hand[k].id,
                  score: this.form_state.multi_choice_arr_hand[k].score,
                }
                this.questionArr.push(question)
              }
            }
            //添加判断题
            if (this.form_state.judge_choice_arr_hand) {
              for (
                let k = 0;
                k < this.form_state.judge_choice_arr_hand.length;
                k++
              ) {
                const question = {
                  id: this.form_state.judge_choice_arr_hand[k].id,
                  score: this.form_state.judge_choice_arr_hand[k].score,
                }
                this.questionArr.push(question)
              }
            }
            //添加填空题
            if (this.form_state.space_choice_arr_hand) {
              for (
                let k = 0;
                k < this.form_state.space_choice_arr_hand.length;
                k++
              ) {
                const question = {
                  id: this.form_state.space_choice_arr_hand[k].id,
                  score: this.form_state.space_choice_arr_hand[k].score,
                }
                this.questionArr.push(question)
              }
            }

            //添加简答题
            if (this.form_state.blank_choice_arr_hand) {
              for (
                let k = 0;
                k < this.form_state.blank_choice_arr_hand.length;
                k++
              ) {
                const question = {
                  id: this.form_state.blank_choice_arr_hand[k].id,
                  score: this.form_state.blank_choice_arr_hand[k].score,
                }
                this.questionArr.push(question)
              }
            }
            //添加综合题
            if (this.form_state.comprehensive_choice_arr_hand) {
              for (
                let k = 0;
                k < this.form_state.comprehensive_choice_arr_hand.length;
                k++
              ) {
                const question = {
                  id: this.form_state.comprehensive_choice_arr_hand[k].id,
                  score: this.form_state.comprehensive_choice_arr_hand[k].score,
                }
                this.questionArr.push(question)
              }
            }

            //计算总分
            for (let k = 0; k < this.questionArr.length; k++) {
              this.paper_score = this.paper_score + this.questionArr[k].score
              console.log('试题分数')
              console.log(this.questionArr[k].score)
            }

            console.log('试卷试题:')
            console.log(this.questionArr)
            console.log(this.paper_score)

            //生成试卷
            this.addPaper()
          }
        } else if (this.tab == '3') {
          console.log('准备生成考试')
          console.log(this.form_exam)
          console.log(this.form_paper)
          console.log(this.form_theme)
          console.log(this.form_score)

          console.log('试题列表')
          console.log(this.questionArr)
        }

        this.tab = this.tab + 1
      }
    },

    getExamQuestionListForPostExam() {
      getExamQuestionListForPostExam({
        questionBankIds: JSON.stringify(this.questionBankIds),
        type: this.question_type,
      }).then((res) => {
        console.log('列出所有试题')
        console.log(res)
        this.questionlist = res.questionList
      })
    },

    PrevStep() {
      if (this.tab !== 0) {
        if (this.tab == '2') {
          this.questionBankIds = []
        }

        this.tab = this.tab - 1
        console.log(this.tab)
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      this.questionBankIds = []
      this.questionBankIds.push(val.id)
    },

    handleSelectionChange1(val) {
      console.log('添加班级列表')
      console.log(val)

      this.selectList = val
      console.log('已有选班级')
      console.log(this.selectList)
    },

    handleSelectionChange2(val) {
      this.selectListStu = val
      console.log('预选学员列表')
      console.log(this.selectListStu)
    },

    getStudentsByClass() {
      console.log('根据班级id组,查询学生列表')
      var class_ids = []
      for (let k = 0; k < this.selectList.length; k++) {
        class_ids.push(this.selectList[k].id)
      }

      console.log('班级id组')
      console.log(class_ids)

      getExamStuListByClassIdsForPostExam({
        classIds: JSON.stringify(class_ids),
      }).then((res) => {
        console.log('考试学员列表')
        console.log(res)

        this.studentList = this.studentList.concat(res.studentList)

        this.studentList = this.unique(this.studentList)

        console.log(this.studentList)
        this.dialogVisible = false
      })
    },

    Choose_student() {
      this.studentList = this.studentList.concat(this.selectListStu)

      this.studentList = this.unique(this.studentList)
      this.dialogVisible1 = false
    },

    //数组对象去重
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },

    handleCurrentChange(val) {
      this.form_bank.page_no = val
    },

    handleCurrentChange1(val) {
      console.log(val)
      this.class_page_no = val
      this.getExamClassListForPostExam()
    },

    handleCurrentChange2(val) {
      this.form_stu.page_no = val
      this.getExamStuListForPostExam()
      console.log(val)
    },

    //生成试卷
    addPaper() {
      console.log('生成试卷参数')
      console.log(this.form_bank.subject_id)
      console.log(this.papername)
      console.log(this.questionArr)

      addPaper({
        subject_id: this.form_bank.subject_id,
        paper_title: this.papername,
        questionBankIds: JSON.stringify(this.questionBankIds),
        questionArr: JSON.stringify(this.questionArr),
      }).then((res) => {
        console.log('生成试卷')
        console.log(res)
        this.new_paper_id = res.new_paper_id
      })
    },

    //试卷预览
    PrevExam() {
      console.log('试卷预览')
      let routeUrl = this.$router.resolve({
        name: 'CommonExam-PaperDetail',
        query: { id: this.new_paper_id, title: this.papername },
      })

      window.open(routeUrl.href, '_blank')
    },

    //发布练习
    SubmitPractice() {
      console.log('保存练习')

      console.log(this.form_exam.post_state)
      console.log(this.form_exam.post_state)

      editPractice({
        exam_id: this.practiceInfo.id,
        show_answer_type: this.form_exam.show_answer_type,
        exam_title: this.form_exam.name, //考试名称
        content: this.form_exam.desc, //考试说明
        start_date: this.form_exam.value[0], //开始时间
        end_date: this.form_exam.value[1], //结束时间
        post_state: this.form_exam.post_state ? 1 : 2, //发布状态 post_state:1 发布状态：1开启 2关闭
        is_show_answer: this.form_exam.is_show_answer ? '1' : '0',
      }).then((res) => {
        console.log('修改练习配置')
        console.log(res)
        if (res.is_update) {
          this.$router.push({
            // name: 'CommonExam-PracticeManagement',
            path: this.backPath,
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper-create-exam {
  box-sizing: border-box;
  min-height: 100%;
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;

  .steps {
    margin-top: 20px;
  }

  .step1 {
    margin-top: 30px;

    .name {
      font-weight: bold;
    }

    .content {
      width: 200px;
      margin-left: 20px;
    }
  }

  .step2 {
    margin-top: 30px;

    .search {
      width: 200px;
    }

    .search_btn {
      margin-left: 20px;
    }

    .questtable {
      margin-top: 0px;
    }

    .pages {
      margin-top: 20px;
      text-align: right;
    }
  }

  .step3 {
    margin-top: 20px;

    .question_modal {
      text-align: center;
      font-size: 18px;
    }
  }

  .modal_random {
    margin-top: 20px;

    .label {
      font-weight: bold;
    }

    .setnum {
      .onechoice {
        margin-top: 20px;
        margin-left: 20px;

        .onechoice_num {
          margin-left: 10px;
        }

        .choose_onechoice {
          margin-left: 100px;
        }

        .onechoice_input_num {
          margin-left: 10px;
          margin-right: 10px;
        }
      }
    }
  }

  .modal_order {
    margin-top: 20px;
  }

  .modal_byhand {
    margin-top: 20px;

    .question_type {
      margin-top: 20px;

      .type {
        font-size: 16px;
        font-weight: bold;
      }

      .el-icon-close {
        float: right;
        font-size: 24px;
        cursor: pointer;
      }

      .el-icon-circle-plus {
        float: right;
        margin-right: 20px;
        font-size: 24px;
        color: #409eff;
        cursor: pointer;
      }

      .question-content {
        .question-info {
          .question-title {
            margin-left: 20px;
            font-size: 16px;
            font-weight: bold;
          }
        }

        .answer-otions {
          margin-top: 20px;

          .option-wrapper {
            float: left;
            width: 100%;
            margin-bottom: 20px;

            .option-tab {
              float: left;
              margin-left: 10px;
              font-weight: bold;
            }

            .option-input {
              float: left;
              width: 500px;
              margin-left: 10px;
              border-radius: 5px;
            }

            .el-icon-edit {
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }

        .answer-setting {
          .set_score {
            margin-left: 10px;
          }

          .control {
            margin-left: 20px;

            .el-icon-delete {
              margin-left: 5px;
              margin-right: 5px;
              cursor: pointer;
            }

            .el-icon-bottom {
              margin-left: 5px;
              margin-right: 5px;
              cursor: pointer;
            }

            .el-icon-top {
              margin-left: 5px;
              margin-right: 5px;
              cursor: pointer;
            }
          }
        }
      }
    }

    .question_scoreset {
      margin-top: 20px;

      .question-set {
        font-size: 16px;
        text-align: center;
        font-weight: bold;
      }

      .set_type {
        margin-bottom: 20px;

        .set_type_onchoice {
          margin-top: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .set_num {
          margin-top: 10px;
          font-size: 14px;

          .total_num {
          }

          .total_score {
            margin-left: 20px;
          }
        }

        .set_score {
          font-size: 14px;
          margin-top: 10px;

          .every_score {
          }

          .every_score_num {
            margin-left: 20px;
          }

          .every_score_label {
            margin-left: 10px;
          }
        }
      }

      .question-total {
        font-size: 14px;
      }

      .question-btn {
        margin-top: 20px;
        text-align: center;
      }
    }
  }

  .step4 {
    margin-top: 20px;

    .base_setting {
      font-weight: bold;
      font-size: 16px;

      .form_exam {
        margin-top: 20px;

        .exam_name {
          width: 300px;
        }
      }
    }

    .paper_setting {
      font-weight: bold;
      font-size: 16px;

      .form_paper {
        margin-top: 20px;
      }
    }

    .theme_setting {
      font-weight: bold;
      font-size: 16px;

      .form3 {
        margin-top: 20px;
      }
    }

    .score_setting {
      font-weight: bold;
      font-size: 16px;

      .form4 {
        margin-top: 20px;
      }
    }

    .class_setting {
      font-weight: bold;
      font-size: 16px;

      .class_label {
      }

      .stu_choose {
        margin-top: 20px;
      }

      .class_list {
        margin-top: 20px;
      }
    }
  }

  .step5 {
    margin-top: 20px;

    .form5 {
      .exam_name {
        width: 300px;
      }
    }
  }

  .control {
    margin-top: 20px;
  }

  .papers {
    margin-top: 20px;

    .form_exam {
      .paper_name {
        width: 300px;
      }
    }
  }
}
</style>

<style>
.wrapper-create-exam .el-dialog__body {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
